export default __webpack_public_path__ + "static/media/LynkcoType-Bold.93efea98.ttf";